import { RtError } from '@recruitee/utils';

export class CodenameInvalidError extends RtError {
  constructor(codename: string) {
    super(`CodenameInvalidError`, `Provided "${codename}" is not supported`);
  }
}
